import {AxiosResponse} from 'axios'
import {axiosInstance} from 'src/utils/axios'
import {Merchant, NewMerchant} from "../types/merchants"
import {ecommerceServiceURL} from "../config"

export type PostMerchants = (body: NewMerchant) => Promise<AxiosResponse<Merchant> | undefined>

export const postMerchants: PostMerchants = async (body: NewMerchant) => {
  try {
    const path = '/v3/merchants'
    const headers = {
      'Content-Type': 'application/json',
    }

    const opts = {
      baseURL: ecommerceServiceURL,
      headers: headers,
    }

    return await axiosInstance.post<Merchant>(path, body, opts)
  } catch (error) {
    console.error('Error creating merchant:', error)
    throw error
  }
}